import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import fp from 'lodash/fp';
import classnames from 'classnames';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import InputField from '@medflex/components/stories/InputField';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const timePipe = createAutoCorrectedDatePipe('HH:MM');
const timePipeWithReset = conformedValue => {
  const result = timePipe(conformedValue);

  if (typeof result === 'object') {
    return result;
  }

  return {
    value: '',
    indexesOfPipedChars: [],
  };
};

const AbsenceEditTimeField = ({ name, id, defaultValue, className }) => {
  const { t } = useTranslation('physician', { keyPrefix: 'InquiryManagementModule.Absence.form' });
  const { formState, register } = useFormContext();
  const { errors } = formState;
  const cn = classnames('flex flex-1', className);

  return (
    <MaskedInput
      id={id}
      name={name}
      placeholder={t('time_placeholder')}
      guide={false}
      keepCharPositions
      pipe={timePipeWithReset}
      mask={[/\d/, /\d/, ':', /\d/, /\d/]}
      defaultValue={defaultValue}
      render={(ref, _props) => (
        <div className={cn}>
          <InputField
            {..._props}
            className="flex-1 max-h-12"
            inputClassName="w-0"
            state={!formState.isValid && fp.get(name)(errors) ? 'invalid' : 'default'}
            ref={node => {
              register(node);
              ref(node);
            }}
          />
        </div>
      )}
    />
  );
};

AbsenceEditTimeField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.func,
    PropTypes.array,
  ]),
};

AbsenceEditTimeField.defaultProps = {
  id: '',
  className: '',
  defaultValue: '',
};

export default AbsenceEditTimeField;
